import { NavLink } from 'react-router-dom';
import { Icon } from './Icon.tsx';
import type { IconName } from './Icon.tsx';

/**
 * 하단 탭.
 * 순서는 기획서 1장을 그대로 따릅니다 — Home 이 가운데(3번)라 엄지 위치와도 맞습니다.
 */
const TABS: { to: string; icon: IconName; label: string }[] = [
  { to: '/partner', icon: 'partner', label: 'Partner' },
  { to: '/book', icon: 'book', label: 'Book' },
  { to: '/', icon: 'home', label: 'Home' },
  { to: '/diary', icon: 'diary', label: 'Diary' },
  { to: '/room', icon: 'room', label: 'Room' },
];

export function TabBar() {
  return (
    <nav className="tabbar" aria-label="주요 화면">
      {TABS.map((tab) => (
        <NavLink key={tab.to} to={tab.to} end={tab.to === '/'} className="tabbar__item">
          <Icon name={tab.icon} size={24} />
          <span>{tab.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
